  //Sidebar- Description and Feature
var acc = document.getElementsByClassName("custom-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("custom-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

//Faq at the bottom
var acc = document.getElementsByClassName("faq-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("faq-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

  $(".custom-default-slider").slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
      });
  
   $(".product-slider-wrapper .custom-code-Black").slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
  });     
  
  $(".product-slider-wrapper .custom-code-Cognac").slick({
        dots: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
  });    

    
    jQuery(document).ready(function(){
    if (window.location.href.indexOf("zen-4") > -1) { 
      setTimeout(function () {
          var checkColor = jQuery('fieldset.colour.variant-picker__option').find('variant-option-value').text();
          checkColor = 'custom-code-'+checkColor;
          jQuery('fieldset.massageoption.variant-picker__option').find('img').addClass('custom-hide');
          jQuery('fieldset.massageoption.variant-picker__option').find('img.'+checkColor).removeClass('custom-hide');
          jQuery('.featured-image-wrapper').find('img').addClass('custom-hide');
          jQuery('.featured-image-wrapper').find('img.'+checkColor).removeClass('custom-hide');
          jQuery('.two-columns-wrapper').find('img').addClass('custom-hide');
          jQuery('.two-columns-wrapper').find('img.'+checkColor).removeClass('custom-hide');
          jQuery('product-gallery').find('.secondary_images_below_gallery').addClass('custom-hide'); 
          jQuery('.product-slider-wrapper').find('.slider-wrapper-both').addClass('custom-hide');
          jQuery('.product-slider-wrapper').find('.outer-'+checkColor).removeClass('custom-hide');
          jQuery('product-gallery').find('.secondary_images_below_gallery.'+checkColor).removeClass('custom-hide');
        
          jQuery(".massage_option .field input").click(function() {
            jQuery('.massage_option .admin__field-option').removeClass('custom-selected');  
            jQuery(this).closest('.admin__field-option').addClass('custom-selected');
          });

          jQuery(".colors .field input").click(function() {
            jQuery('.colors .admin__field-option').removeClass('custom-selected-border');  
            jQuery(this).closest('.admin__field-option').addClass('custom-selected-border');
          });

          jQuery(".color-swatch").click(function() { 
              var variant_code = jQuery(this).attr('color-variant'); 
              jQuery('fieldset.massageoption.variant-picker__option').find('img').addClass('custom-hide');
              jQuery('fieldset.massageoption.variant-picker__option').find('img.'+variant_code).removeClass('custom-hide');
              jQuery('.featured-image-wrapper').find('img').addClass('custom-hide');
              jQuery('.featured-image-wrapper').find('img.'+variant_code).removeClass('custom-hide');
              jQuery('.two-columns-wrapper').find('img').addClass('custom-hide');
              jQuery('.product-slider-wrapper').find('.slider-wrapper-both').addClass('custom-hide');
              jQuery('.product-slider-wrapper').find('.'+variant_code).slick('refresh');
              jQuery('.product-slider-wrapper').find('.outer-'+variant_code).removeClass('custom-hide'); 
              jQuery('.two-columns-wrapper').find('img.'+variant_code).removeClass('custom-hide');
              jQuery('product-gallery').find('.secondary_images_below_gallery').addClass('custom-hide');
              jQuery('product-gallery').find('.secondary_images_below_gallery.'+variant_code).removeClass('custom-hide');
         });   
      }, 2500); 
    }
    });  
    if (window.location.href.indexOf("zen-4") > -1) {  
    var massage_status = '<div class="massage-label">';
    massage_status+= '<img massage-variant="custom-code-Cognac" class="custom-code-Cognac custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/cognac-no-massage.png" alt="cognac-no-massage" />';
    massage_status+= '<img massage-variant="custom-code-Black" class="custom-code-Black custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/black-no-massage.png" alt="black-no-massage" />';
    massage_status+= '</div>';
    jQuery('.massageoption label:eq(0)').append(massage_status);

    var massage_status1 = '<div class="massage-label">';
    massage_status1+= '<img massage-variant="custom-code-Cognac" class="custom-code-Cognac custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/cognac-massage.png" alt="cognac-massage" />';
    massage_status1+= '<img massage-variant="custom-code-Black" class="custom-code-Black custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/black-massager.png" alt="black-massage" />';
    massage_status1+= '</div>';
    jQuery('.massageoption label:eq(1)').append(massage_status1);

    var wheeloptions = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png" alt="regular-wheel" />';
    jQuery('.wheeloptions label:eq(0)').append(wheeloptions);

    var wheeloptions1 = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png" alt="roller-coaster" />';
    jQuery('.wheeloptions label:eq(1)').append(wheeloptions1);
    }
    else if (window.location.href.indexOf("zen-2") > -1) { 
      var massage_status = '<div class="massage-label">';
      massage_status+= '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-no-massage.png" alt="zen-2-no-massage" />';
      massage_status+= '</div>';
      jQuery('.massageoption label:eq(0)').append(massage_status);
  
      var massage_status1 = '<div class="massage-label">';
      massage_status1+= '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-massage.png" alt="zen-2-massage" />';
      massage_status1+= '</div>';
      jQuery('.massageoption label:eq(1)').append(massage_status1);
  
      var wheeloptions = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png" alt="regular-wheel" />';
      jQuery('.wheeloptions label:eq(0)').append(wheeloptions);
  
      var wheeloptions1 = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png" alt="roller-coaster" />';
      jQuery('.wheeloptions label:eq(1)').append(wheeloptions1);
    }  
    else if (window.location.href.indexOf("zen-3") > -1) { 
      var massage_status = '<div class="massage-label">';
      massage_status+= '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-no-massage.png" alt="zen-2-no-massage" />';
      massage_status+= '</div>';
      jQuery('.massageoption label:eq(0)').append(massage_status);
  
      var massage_status1 = '<div class="massage-label">';
      massage_status1+= '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-massage.png" alt="zen-2-massage" />';
      massage_status1+= '</div>';
      jQuery('.massageoption label:eq(1)').append(massage_status1);
  
      var wheeloptions = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png" alt="regular-wheel" />';
      jQuery('.wheeloptions label:eq(0)').append(wheeloptions);
  
      var wheeloptions1 = '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png" alt="roller-coaster" />';
      jQuery('.wheeloptions label:eq(1)').append(wheeloptions1);
    }  
    jQuery(document).ready(function(){
      setTimeout(function () { 
        var wrapper = jQuery('#below-gallery-wrapper').html();
        jQuery(wrapper).insertAfter('#magic-zoom-plus-block');
      }, 2000);

      setTimeout(function () { 
          //Hide SIRV Branding
          jQuery('.sirv-spin.smv-cursor-zoom-in').next('a').attr('style','display: none !important');
      }, 4000);  
        
    }); 

